import { AxiosResponse } from 'axios';
import { get, post } from 'services/api';

export const getContact = (): Promise<AxiosResponse> => get('settings/contact');

export const saveContact = (formData: any): Promise<AxiosResponse> =>
  post('settings/contact', formData);

export const sendEmail = (formData: { subject: string; message: string }): Promise<AxiosResponse> =>
  post('contact/send-mail', formData);
